/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { getRequest, delRequest } from "../../../axiosRoutes/index";
import {
  Button,
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Pagination,
  Snackbar,
  Alert,
  Card,
  CardContent,
  CardActions,
  useMediaQuery,
} from "@mui/material";
import SideNavBar from "../sidebar/SideNav";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "../../../axiosRoutes/snackbarConfig";
import AddMedical from "./AddMedical";
import { useInView } from "react-intersection-observer";

const Medical = () => {
  const { snackbar, showSnackbar, handleSnackbarClose } = useSnackbar();
  const [hover, setHover] = useState(null);
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const [statuses, setStatuses] = useState([]);
  const [medicalAllowances, setMedicalAllowances] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [medicalId, setMedicalId] = useState(null);
  const [openImage, setOpenImage] = useState(false);
  const [openMedical, setOpenMedical] = useState(false);
  const [medicalData, setMedicalData] = useState({
    name: "",
    date: "",
    reason: "",
    status: "",
    comments: "",
    amount: "",
    imageUrl: "",
  });
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [isFetchingMedical, setIsFetchingMedical] = useState(false)
  const { ref, inView } = useInView({
    threshold: 0,
  });
  const [limit, setLimit] = useState(10)

  useEffect(() => {
    if (inView) {
      if (limit < totalPages * 10) {
        setLimit((prev) => prev + 10);
      }
    }
  }, [inView]);

  const fetchStatus = async () => {
    try {
      const response = await getRequest("filter/status");
      const statusArray = Object.keys(response).map((key) => ({
        label: key,
        value: response[key],
      }));
      setStatuses(statusArray);
    } catch (error) {
      console.error("Error fetching Filter:", error);
    }
  };

  const handleOpenImage = () => {
    setOpenImage(true);
  };
  const handleCloseImage = () => {
    setOpenImage(false);
  };

  const fetchMedicals = async () => {
    const id = localStorage.getItem("userId");
    const access = localStorage.getItem("access");
    try {
      !isSmallScreen && setLoading(true)
      setIsFetchingMedical(true)
      const response = await getRequest(
        `employee/medicalAllowance/user/${id}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
          params: !isSmallScreen ? { page: page } : { limit: limit }
        }
      );
      setIsFetchingMedical(false)
      setTotalPages(response?.totals?.total_pages)
      const formattedMedical = response?.data.map((medical) => {
        if (medical.date) {
          const date = new Date(medical.date);
          medical.date = date.toLocaleDateString("en-GB");
        }
        const statusObj = statuses.find(
          (status) => status.value === medical.status
        );
        medical.status = statusObj ? statusObj.label : medical.status;
        return medical;
      });
      setMedicalAllowances(formattedMedical)
    } catch (error) {
      console.error("Error fetching Medical Allowances:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchStatus();
    };
    fetchData();
  }, [page, limit]);

  useEffect(() => {
    if (statuses.length > 0) {
      fetchMedicals();
    }
  }, [statuses]);

  const handleDelete = async () => {
    try {
      const access = localStorage.getItem("access");
      const response = await delRequest(
        `employee/medicalAllowance/${deleteId}`,
        access
      );
      handleClose();
      showSnackbar(response, "success");
      fetchMedicals();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClickOpen = (id) => {
    setDeleteId(id);
    setOpen(true);
  };

  const selectMedical = (id) => {
    setUpdateId(id);
    handleOpen();
  };

  const handleMedical = (id) => {
    setOpenMedical(true);
    setMedicalId(id);
  };

  useEffect(() => {
    const fetchMedical = async () => {
      if (medicalId !== null) {
        const access = localStorage.getItem("access");
        try {
          setLoading(true);
          const response = await getRequest(
            `employee/medicalAllowance/${medicalId}`,
            {
              headers: {
                Authorization: `Bearer ${access}`,
              },
              params: !isSmallScreen ? { page: page } : { limit: limit }
            }
          );
          const formatDate = new Date(response.date)
            .toISOString()
            .split("T")[0];
          let returnStatus = () => {
            return statuses.find(
              (status) => status.value === response.status
            )?.label
          }
          setMedicalData({
            name: response.name,
            date: formatDate,
            reason: response.reason,
            status: returnStatus(),
            comments: response.comments || "N/A",
            amount: response.amount,
            imageUrl: response.imageUrl,
          });
        } catch (error) {
          console.error("Error fetching Medical Allowances:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setMedicalData({
          name: "",
          date: "",
          reason: "",
          status: "",
          comments: "",
          amount: "",
          imageUrl: "",
        });
      }
    };
    fetchMedical();
  }, [medicalId]);

  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
    setOpenMedical(false);
    fetchMedicals();
    setMedicalId(null);
    setDeleteId(null);
    setUpdateId(null);
  };

  const headingTableCellStyle = {
    color: "#fff",
    textAlign: "center",
    borderBottom: "2px solid #1F1F1F",
    fontSize: { xs: "0.8rem", sm: "1rem" },
    backgroundColor: '#1F1F1F'
  }

  const dataTableCellStyle = (hover, id) => {
    return {
      color: hover === id ? "#FF5722" : "#fff",
      textAlign: "center",
      borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
      fontSize: { xs: "0.8rem", sm: "1rem" },
      padding: '10px 16px',
      backgroundColor: '#292929'
    };
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        textAlign="center"
      >
        <CircularProgress size={50} sx={{ color: "#FF5722" }} />
        <Typography variant="h6" sx={{ marginTop: "18px", color: "#fff" }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <div className="app-container" style={{ color: "#fff", display: "flex" }}>
        <SideNavBar />
        <div style={{ flex: 1, margin: `${isSmallScreen ? '3.2rem' : '0.5rem'} 0.5rem 0.5rem 0.5rem` }}>
          <Box sx={{ backgroundColor: "#000", marginTop: { xs: 1, md: 0 } }}>
            <Grid
              container
              sx={{
                alignItems: "center",
                justifyContent: { xs: "center", md: "space-between" },
                flexDirection: { xs: "column", md: "row" },
                padding: "1rem",
              }}
            >
              <Grid item>
                <h1>Medical Allowance</h1>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={handleOpen}
                  sx={{
                    backgroundColor: "#fff",
                    color: "black",
                    "&:hover": {
                      backgroundColor: "#e1e1e1",
                    },
                  }}
                >
                  Add Medical Allowance
                </Button>
              </Grid>
            </Grid>
            {medicalAllowances.length === 0 ? (
              <Typography variant="h6" sx={{ color: "#fff", textAlign: "center" }}>
                No Data Yet
              </Typography>
            ) : (
              <>
                {!isSmallScreen ? (
                  <TableContainer sx={{ overflowX: "auto", maxWidth: "100vw" }}>
                    <Table
                      style={{
                        borderRadius: "25px",
                        borderCollapse: "separate",
                        overflow: "hidden",
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell sx={headingTableCellStyle}>ID</TableCell>
                          <TableCell sx={headingTableCellStyle}>
                            Reason
                          </TableCell>
                          <TableCell sx={headingTableCellStyle}>
                            Amount
                          </TableCell>
                          <TableCell sx={headingTableCellStyle}>
                            Comments
                          </TableCell>
                          <TableCell sx={headingTableCellStyle}>Date</TableCell>
                          <TableCell sx={headingTableCellStyle}>
                            Status
                          </TableCell>
                          <TableCell sx={headingTableCellStyle}>
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {medicalAllowances.map((medicalAllowance, id) => (
                          <TableRow key={id}
                            style={{
                              cursor: "pointer",
                            }}
                            onMouseEnter={() => setHover(id)}
                            onMouseLeave={() => setHover(null)}
                            onClick={() => handleMedical(medicalAllowance._id)}>
                            <TableCell sx={dataTableCellStyle(hover, id)}>
                              {(page - 1) * 10 + id + 1}
                            </TableCell>
                            <TableCell sx={dataTableCellStyle(hover, id)}>
                              {medicalAllowance.reason}
                            </TableCell>
                            <TableCell sx={dataTableCellStyle(hover, id)}>
                              {medicalAllowance.amount}
                            </TableCell>
                            <TableCell sx={dataTableCellStyle(hover, id)}>
                              {medicalAllowance.comments || "N/A"}
                            </TableCell>
                            <TableCell sx={dataTableCellStyle(hover, id)}>
                              {medicalAllowance.date}
                            </TableCell>
                            <TableCell sx={dataTableCellStyle(hover, id)}>
                              {medicalAllowance.status}
                            </TableCell>
                            <TableCell sx={dataTableCellStyle(hover, id)}>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#1976D2",
                                  marginRight: "5px",
                                }}
                                aria-label="view"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleMedical(medicalAllowance._id)
                                }}
                              >
                                <VisibilityIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor:
                                    medicalAllowance.status === "Approved"
                                      ? "#86c886"
                                      : "#4CAF50",
                                  marginRight: "5px",
                                }}
                                disabled={medicalAllowance.status === "Approved"}
                                aria-label="edit"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  selectMedical(medicalAllowance._id)
                                }}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor:
                                    medicalAllowance.status === "Approved"
                                      ? "#ff8575"
                                      : "#F44336",
                                  marginRight: "5px",
                                }}
                                disabled={medicalAllowance.status === "Approved"}
                                aria-label="delete"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOpen(medicalAllowance._id)
                                }}
                              >
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter style={{ backgroundColor: "#1F1F1F" }}>
                        <TableRow>
                          <TableCell
                            colSpan={100}
                            style={{
                              color: "white",
                              border: "none",
                              textAlign: "center",
                            }}
                          >
                            <Pagination
                              count={totalPages}
                              variant="outlined"
                              color="primary"
                              page={page}
                              onChange={(e, value) => {
                                setPage(value);
                              }}
                              sx={{
                                display: "inline-block",
                                "& .MuiPaginationItem-root": {
                                  color: "#fff",
                                  borderColor: "#fff",
                                  transition: "all 0.3s ease",
                                  "&:hover": {
                                    backgroundColor: "#FF5722",
                                    color: "#fff",
                                    borderColor: "#FF5722",
                                  },
                                  "&.Mui-selected": {
                                    backgroundColor: "#FF5722",
                                    color: "#fff",
                                    borderColor: "#FF5722",
                                  },
                                },
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                ) : (
                  <Grid container spacing={1}>
                    {medicalAllowances.map((medicalAllowance, id) => (
                      <Grid item xs={12} key={id}>
                        <Card ref={id + 1 === medicalAllowances.length ? ref : null}
                          sx={{
                            backgroundColor: "#101010",
                            color: "#fff",
                          }}
                          onMouseEnter={() => setHover(id)}
                          onMouseLeave={() => setHover(null)}
                          onClick={() => handleMedical(medicalAllowance._id)}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <CardContent>
                              <Typography variant="h6">
                                {medicalAllowance.name}
                              </Typography>
                              <Typography variant="body2">
                                Amount Reimbursed: {medicalAllowance.amountReimbursed}
                                <br />
                                Date: {medicalAllowance.date}
                                <br />
                                Status: {medicalAllowance.status}
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#1976D2",
                                  marginRight: "1px",
                                }}
                                aria-label="view"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleMedical(medicalAllowance._id)
                                }}
                              >
                                <VisibilityIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor:
                                    medicalAllowance.status === "Approved"
                                      ? "#86c886"
                                      : "#4CAF50",
                                  marginRight: "1px",
                                }}
                                disabled={medicalAllowance.status === "Approved"}
                                aria-label="edit"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  selectMedical(medicalAllowance._id)
                                }}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor:
                                    medicalAllowance.status === "Approved"
                                      ? "#ff8575"
                                      : "#F44336",
                                  marginRight: "1px",
                                }}
                                disabled={medicalAllowance.status === "Approved"}
                                aria-label="delete"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOpen(medicalAllowance._id)
                                }}
                              >
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </CardActions>
                          </Box>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                )}
              </>
            )}
          </Box>
          <Dialog
            open={openMedical}
            maxWidth
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                opacity: 0.9,
                color: "#fff",
                padding: "5px",
                maxWidth: { xs: "90%", md: "40%" },
                border: "2px solid #D0521B",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "22px",
                fontWeight: "bold",
              }}
            >
              {medicalData.name}
              <IconButton
                onClick={handleClose}
                sx={{
                  color: "#fff",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Grid container justifyContent="space-between" alignItems="center" sx={{ borderTop: "2px solid #D0521B", paddingTop: "1rem", }}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Employee name:</b> {medicalData.name}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Reason:</b> {medicalData.reason}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Amount:</b> {medicalData.amount}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Comments:</b> {medicalData.comments}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Date:</b> {medicalData.date}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Status:</b> {medicalData.status}
                  </Typography>
                </Grid>
                <Grid item xs={12} sx={{ textAlign: "center", mt: 5 }}>
                  <img
                    src={medicalData.imageUrl}
                    alt="Preview"
                    style={{ maxWidth: isSmallScreen ? "90%" : "25%", height: "auto", borderRadius: "8px" }}
                    onClick={handleOpenImage}
                  />
                  <Dialog open={openImage} onClose={handleCloseImage} >
                    <DialogContent sx={{ textAlign: "center", p: 0 }}>
                      <img
                        src={medicalData.imageUrl}
                        alt="Full Screen"
                        style={{ maxWidth: isSmallScreen ? "85vw" : "auto", height: isSmallScreen ? "auto" : "80vh", borderRadius: "8px" }}
                      />
                    </DialogContent>
                  </Dialog>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
          <Dialog
            open={open}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                color: "#fff",
                padding: "15px",
              },
              "& .MuiDialogTitle-root": {
                padding: "5px",
              },
              "& .MuiDialogContentText-root": {
                color: "#fff",
              },
              "& .MuiDialogContent-root": {
                padding: "5px",
              },
              "& .MuiDialogActions-root": {
                padding: "5px",
              },
            }}
          >
            <DialogTitle>Confirm Deletion</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete this Medical Allowance?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                sx={{
                  backgroundColor: "#A6A6A6",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#B8B8B8" },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                sx={{
                  backgroundColor: "#E5622D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#D0521B" },
                }}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          <AddMedical
            open={openModal}
            handleClose={handleClose}
            medicalId={updateId}
          />
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {isSmallScreen && <Grid container width='100%' height='10vh' alignItems='center' justifyContent='center' style={{ position: 'fixed', bottom: (isFetchingMedical ? '20px' : '-100px'), transition: 'bottom 0.5s ease' }}>
        <CircularProgress size="3rem" sx={{ color: "#FF5722" }} />
      </Grid>}
    </>
  );
};

export default Medical;
